import { useContext, useMemo } from 'react';
import { TextureLoader, DoubleSide } from 'three';

import { GameContext, ViewContext } from '@/state/contexts';

// replace with texture of "Buy" in league spartan bold
// shows up in space above what would be next factory
// click to launch same buy factory model

const Button3D = ({ buttonAction, type = 'buy', playerId, p = [0, 0, 0] }) => {
	const scale = 0.75;
	const buttonHeight = 1 * scale;
	const buttonWidth = 2 * buttonHeight;

	const pc: any = useContext(GameContext);

	let pos: [x: number, y: number, z: number] = [
		p[0] || 0,
		p[1] || 0,
		p[2] || 0,
	];

	const {
		buyButtonTexturePath,
		donateButtonTexturePath,
		stealButtonTexturePath,
		storeButtonTexturePath,
		paymentMode,
	}: any = useContext(ViewContext);

	const buttonBuyTexture = useMemo(
		() => new TextureLoader().load(buyButtonTexturePath),
		[]
	);
	const buttonDonateTexture = useMemo(
		() => new TextureLoader().load(donateButtonTexturePath),
		[]
	);
	const buttonStealTexture = useMemo(
		() => new TextureLoader().load(stealButtonTexturePath),
		[]
	);
	const buttonStoreTexture = useMemo(
		() => new TextureLoader().load(storeButtonTexturePath),
		[]
	);

	if (!pc) return;

	let buttonTexture = buttonBuyTexture;

	if (type === 'donate') buttonTexture = buttonDonateTexture;
	if (type === 'steal') buttonTexture = buttonStealTexture;
	if (type === 'store') buttonTexture = buttonStoreTexture;

	// skip if it's not my turn, it's not my playermat or paymentMode
	if (
		pc.activePlayerId !== pc.currPlayer.playerId ||
		pc.activePlayerId !== playerId ||
		paymentMode
	) {
		return;
	}

	return (
		<group>
			<mesh
				visible
				userData={{ hello: 'world' }}
				position={pos}
				rotation={[0, 0, 0]}
				onClick={(e) => {
					e.stopPropagation();
					buttonAction();
				}}
			>
				<boxGeometry args={[buttonWidth, 0.25, buttonHeight]} />
				<meshBasicMaterial
					attach="material"
					map={buttonTexture}
					side={DoubleSide}
				/>
			</mesh>
		</group>
	);
};

export default Button3D;
